import styled from 'styled-components';

interface ResponsiveProps {
  isDesktopBig?: boolean;
  isDesktopMedium?: boolean;
  isDesktopOrLaptop?: boolean;
  isMiniNotebook?: boolean;
  isMobileBig?: boolean;
  isMobileMedium?: boolean;
  isMobileMini?: boolean;
}


export const Container = styled.div<ResponsiveProps>`
  padding: ${({ isMobileMini, isMobileMedium, isMobileBig, isMiniNotebook }) =>
    isMobileMini ? '22px 8px 10px 8px' : isMobileMedium ? '22px 8px 10px 8px' : isMobileBig ? '24px 12px 12px 12px' : isMiniNotebook ? '28px 14px 16px 14px' : '32px 16px 18px 16px'};
  
  border-radius: 12px;
  box-shadow: 0 12px 12px rgba(0, 0, 0, 0.1);
  max-width: ${({ isMobileMini, isMobileMedium, isMobileBig, isMiniNotebook, isDesktopOrLaptop, isDesktopMedium, isDesktopBig }) =>
    isMobileMini ? '355px' : isMobileMedium ? '500px' : isMobileBig ? '700px' : isMiniNotebook ? '800px' : isDesktopOrLaptop ? '900px' : isDesktopMedium ? '950px' : isDesktopBig ? '1350px' : '1350'};
  min-width: 200px;
  background-color:rgb(255, 253, 251);
  margin-bottom:25px;
`;

